import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Toaster } from "@/components/ui/sonner";
import FeedbackButton from "@/components/FeedbackButton";
import ScrollManager from "@/components/ScrollManager";
import VerificationPrompt from "@/components/VerificationPrompt";
import VendorsLaunchPopup from "@/components/VendorsLaunchPopup";
import { useRoomsLive } from "@/hooks/useRooms";

const MainLayout = () => {
  const location = useLocation();

  // The live connection lives here, above every layout, because it must not be
  // torn down by ordinary navigation. AppShell is mounted in three separate
  // places and /companies uses a different layout entirely, so holding it one
  // level down closed the socket on each crossing and minted a fresh token —
  // sixty of those in an hour and the member is throttled out of live
  // messaging altogether. The hook returns early without a signed-in member,
  // so logging out still closes it.
  useRoomsLive();

  // Only show footer on the public landing page
  const showFooter = location.pathname === '/';

  return (
    <div className="flex flex-col min-h-screen">
      <ScrollManager />
      <Navbar />
      {/* ScrollManager moves focus here on a new page; the region itself isn't a control, so no ring. */}
      <main className="flex-1 pt-20 focus:outline-none">
        <Outlet />
      </main>
      <Toaster />
      {showFooter && <Footer />}
      <FeedbackButton />
      <VerificationPrompt />
      {/* Never on the same visit as the verification pop-up: the server holds that one back while this is due or just shown. */}
      <VendorsLaunchPopup />
    </div>
  );
};

export default MainLayout;
